import { type FormikHelpers as FormikActions } from 'formik'
import { type Moment } from 'moment'

import {
  type AccountCode,
  type BudgetCategory,
  type Department,
  type User,
} from '@webapp/models'
import { type Enum } from '@webapp/utils/enums'
import { type BudgetIntervalOption } from '../BudgetIntervalSelect/BudgetIntervalSelect'

export interface IBudgetCategoryFormProps {
  initialValues?: Partial<BudgetCategoryFormFormSchema>
  isRequesterBudgetVisibilityEnabled?: boolean
  onCancel?(): void
  onSubmit?(
    values: BudgetCategoryFormFormSchema,
    FormikActions: FormikActions<BudgetCategoryFormFormSchema>
  ): void
}

export type DateRangeErrorDetails = {
  title: string
  msg: string
}

export const DateRangeErrorTypes = {
  TOO_LARGE: 'TooLarge',
  OVERLAP: 'Overlap',
} as const

export type DateRangeErrorType = Enum<typeof DateRangeErrorTypes>

export type BudgetGroupFormSchema = {
  dates: {
    startDate: Moment
    endDate: Moment
  }
  budgets: number[]
}

export interface BudgetGroupErrors extends BudgetGroupFormSchema {
  dateRange: string
}

export interface BudgetCategoryFormFormSchema {
  id?: BudgetCategory['id']
  uuid?: BudgetCategory['uuid']
  isSourceOfTruth?: boolean
  hasBudgetFields?: boolean
  budgetInterval?: BudgetIntervalOption
  budgetGroups?: BudgetGroupFormSchema[]
  hasCustomBudgets?: boolean
  name: string
  departments: Department[]
  accountCodes: AccountCode[]
  users: User[]
}
